import { SystemActionsList } from '@wix/editor-platform-host-integration-apis';
import { PlatformContext } from '../types';
import { createPackagePickerService } from '../../SdkEventHandlerService/services/packagePicker/packagePickerService';

export const upgradeActionFactory = (context: PlatformContext) => {
  const { editorPointer, documentServicesAPI, hostAPI, editorPointerAPI } =
    context;

  let packagePickerServiceInstance: ReturnType<
    typeof createPackagePickerService
  > | null = null;

  const getPackagePickerService = () => {
    if (!packagePickerServiceInstance) {
      packagePickerServiceInstance = createPackagePickerService(
        hostAPI,
        documentServicesAPI,
      );
    }
    return packagePickerServiceInstance;
  };

  const getComponentData = () => {
    const compRef = editorPointerAPI.getDocumentPointer(editorPointer);
    const compData = documentServicesAPI.components.data.get(compRef);
    return compData;
  };

  const getAppData = (appDefinitionId: string) => {
    return documentServicesAPI.tpa.app.getDataByAppDefId(appDefinitionId);
  };

  return {
    actionName: SystemActionsList.upgrade,
    displayName: 'Upgrade',
    tags: [],
    execute: async () => {
      const compData = getComponentData();

      if (!compData?.appDefinitionId) {
        throw new Error(
          'No app definition ID found for the selected component',
        );
      }

      const packagePickerService = getPackagePickerService();
      packagePickerService.startUpgradeFlow(compData.appDefinitionId, {
        origin: 'upgrade_action',
      });
    },
    shouldBeExcluded: () => {
      try {
        const compData = getComponentData();

        if (!compData?.appDefinitionId) {
          return true;
        }

        const appData = getAppData(compData.appDefinitionId);

        if (!appData) {
          return true;
        }

        const packagePickerService = getPackagePickerService();

        const shouldExclude = packagePickerService.isFullyUpgraded(appData);

        return shouldExclude;
      } catch (error) {
        // If there's any error, exclude the upgrade action
        return true;
      }
    },
  };
};
